import '@babel/polyfill';
import annoucementVisibility from './lib/_announcement';
import handleCart from './lib/_handleCart';
import handleBanner from './lib/_handleBanner';
import initBlankshield from './lib/_initBlankshield';
import handleBio from './lib/_handleBio';
import toggleCartIcon from './lib/_toggleCartIcon';

/**
 * Class representing Paradigm's custom JavaScript for pre-made Shopify theme
 */
class ParadigmUtilityClass {
  /**
   * Select all elements within DOM that match @param element
   * @param {string} element - CSS class
   * @return {array} - An array containing all HTMLElements that match passed in CSS class
   */
  selectAllElements = (element) => {
    return Array.from(document.querySelectorAll(element));
  }

  /**
   * Handles toggling a css class for passed in HTMLElement
   * Controls necessary aria attributes for accessibility
   * @param {string} cssClass - CSS class that will be added/removed to @param elements
   * @param {string} elements - CSS class that returns a HTMLElement where our @param eventType will be applied
   * @param {string} eventType - Any JavaScript event.  Examples:  click, mouseover, etc.
   * @param {string} ariaElement - CSS class that selects element we're controlling our aria attributes on.
   * @param {string} additionalElements - CSS class that selects element we're controlling our aria attributes on.
   * @param {string} htmlClass - CSS class that will be applied to <html>.  Default value is set as an empty string
   * @param {string} traversingOptions.sibling - Accepts either 'prev' or 'next' to traverse up or down the DOM
   * @param {string} traversingOptions.ariaProp - Accepts valid aria attributes to modify in conjunction with @param traversingOptions.sibling
   */
  toggleClass = ({ cssClass, elements, eventType, ariaElement, additionalElements, htmlClass = '', traversingOptions }) => {
    this.selectAllElements(elements).forEach((item) => {
      item.addEventListener(eventType, function toggleThis() {
        const selectedAriaElement = document.querySelector(ariaElement);
        const selectedAdditionalElement = document.querySelector(additionalElements);
        (selectedAriaElement || this).setAttribute('aria-expanded', !JSON.parse((selectedAriaElement || this).getAttribute('aria-expanded')));
        if (JSON.parse((selectedAriaElement || this).getAttribute('aria-expanded'))) {
          this.classList.add(cssClass);
          if (selectedAdditionalElement !== null) { selectedAdditionalElement.classList.add(cssClass); }
        } else {
          Array.from(document.querySelectorAll(`.${cssClass}`)).forEach((activeElement) => { activeElement.classList.remove(cssClass); });
        }
        // Since traversingOptions is an optional parameter, check that it exists
        if ({ traversingOptions }.traversingOptions !== undefined) {
          const childArr = [...this.parentNode.children];
          childArr.forEach((child) => { child.classList.toggle(cssClass); });
          switch (traversingOptions.sibling.type) {
            case 'next':
              this.nextElementSibling.setAttribute(
                traversingOptions.sibling.ariaProp, !JSON.parse(this.nextElementSibling.getAttribute(traversingOptions.sibling.ariaProp))
              );
              break;
            case 'prev':
              this.previousElementSibling.setAttribute(
                traversingOptions.sibling.ariaProp, !JSON.parse(this.previousElementSibling.getAttribute(traversingOptions.sibling.ariaProp))
              );
              break;
            default:
              break;
          }
        }
        // Return out of method if no htmlClass is provided
        if (htmlClass.length === 0) {
          return;
        }
        document.documentElement.classList.toggle(htmlClass);
      }, false);
    });
  }
}



const pnmgCarousel = () => {
  /* eslint-disable */
  $(document).ready(function(){
    $('.carousel').slick({
      slidesToShow: 3,
      mobileFirst: true,
      dots: true,
      arrows: false,
      responsive: [
        {
          breakpoint: 319,
          settings: {
            slidesToShow: 1
          }
        },
        {
          breakpoint: 639,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 959,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1279,
          settings: {
            dots: false,
            arrows: true
          }
        }
      ]
    });
  });
  /* eslint-enable */
};



document.onreadystatechange = () => {
  if (document.readyState === 'complete') {
    const pnmg = new ParadigmUtilityClass();
    // Blog Menu
    pnmg.toggleClass({
      cssClass: 'is-active',
      elements: '.js-toggle',
      eventType: 'click',
      htmlClass: 'cat-nav__menu--is-active',
      ariaElement: '.cat-nav__menu',
      additionalElements: '.icon__arrow--down'
    });
    // Blog Menu Arrow
    pnmg.toggleClass({
      cssClass: 'is-active',
      elements: '.icon__arrow--down',
      eventType: 'click',
      htmlClass: 'cat-nav__menu--is-active',
      ariaElement: '.cat-nav__menu',
      additionalElements: '.icon__arrow--down'
    });
    annoucementVisibility();
    toggleCartIcon();
    handleBanner();
    handleCart();
    pnmgCarousel();
    handleBio();
    initBlankshield();
  }
};
